import { createContext, useContext } from 'react'
import { TransitionStage } from './TransitionList/constants'

export enum AnimationType {
  back = 'back',
  next = 'next',
  fade = 'fade',
  none = 'none',
  overlay = 'overlay',
}

interface AnimationFinishCallback {
  (): void
}

export interface AnimationState {
  visible: boolean
  stage: TransitionStage
  type: AnimationType
  delay: number
  duration: number
  createAnimation: () => AnimationFinishCallback
  blockEnter: () => AnimationFinishCallback
  blockLeave: () => AnimationFinishCallback
}

const nuzz = () => {}
const nuzzActionFactory = () => nuzz

export const animationStateContext = createContext<AnimationState>({
  visible: true,
  stage: TransitionStage.normal,
  type: AnimationType.next,
  delay: 0,
  duration: 0,
  createAnimation: nuzzActionFactory,
  blockEnter: nuzzActionFactory,
  blockLeave: nuzzActionFactory,
})

export const useAnimationState = () => {
  return useContext(animationStateContext)
}
